import type { GateDefinition, GateContext } from './gates.types'
import { isTenantGate } from './gates.types'

export function resolveGate(
  definition: GateDefinition,
  ctx: GateContext
): boolean {
  if (typeof definition === 'function') {
    return definition(ctx)
  }

  if (isTenantGate(definition)) {
    const tenantFn = definition[ctx.tenant]
    return tenantFn ? tenantFn(ctx) : false
  }

  return false
}
